import { TableColumnMeta } from "ds/components/Table/types";

export const SCAN_RUNS_COLUMNS_STORAGE_KEY = "scanRunsColumnsConfig";
export const SCAN_RUNS_LIMIT = 25;
export const SCAN_RUNS_LIMIT_STORAGE_KEY = "scanRunsLimit";
export const SCAN_RUNS_PAGINATION_OPTIONS = [25, 50];

export enum SCAN_RUNS_COLUMN_ID {
  SCHEDULED = "SCHEDULED",
  STATUS = "STATUS",
  DURATION = "DURATION",
  TOTAL_RESOURCES = "TOTAL_RESOURCES",
  UNMANAGED_RESOURCES = "UNMANAGED_RESOURCES",
  SETTINGS = "SETTINGS",
}

const MAX_CELL_WIDTH = 1200;

export const SCAN_RUNS_COLUMN_CONFIG: Record<SCAN_RUNS_COLUMN_ID, TableColumnMeta> = {
  [SCAN_RUNS_COLUMN_ID.SCHEDULED]: {
    id: SCAN_RUNS_COLUMN_ID.SCHEDULED,
    title: "Scheduled",
    minWidth: 150,
    defaultWidth: 280,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: false,
    configurable: true,
  },
  [SCAN_RUNS_COLUMN_ID.STATUS]: {
    id: SCAN_RUNS_COLUMN_ID.STATUS,
    title: "Status",
    minWidth: 120,
    defaultWidth: 160,
    maxWidth: 240,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    configurable: true,
  },
  [SCAN_RUNS_COLUMN_ID.DURATION]: {
    id: SCAN_RUNS_COLUMN_ID.DURATION,
    title: "Duration",
    minWidth: 100,
    defaultWidth: 140,
    maxWidth: 220,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    configurable: true,
  },
  [SCAN_RUNS_COLUMN_ID.TOTAL_RESOURCES]: {
    id: SCAN_RUNS_COLUMN_ID.TOTAL_RESOURCES,
    title: "Total resources",
    minWidth: 130,
    defaultWidth: 180,
    maxWidth: 280,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    configurable: true,
  },
  [SCAN_RUNS_COLUMN_ID.UNMANAGED_RESOURCES]: {
    id: SCAN_RUNS_COLUMN_ID.UNMANAGED_RESOURCES,
    title: "Unmanaged resources",
    minWidth: 150,
    defaultWidth: 220,
    maxWidth: 320,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    configurable: true,
  },
  [SCAN_RUNS_COLUMN_ID.SETTINGS]: {
    id: SCAN_RUNS_COLUMN_ID.SETTINGS,
    title: "Table settings",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
  },
};
